import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
export const Container = (param)=>{
    let { id, className, extraProps, size = 'm', gutter = false, children } = param;
    const containerMod = `container--${size}${gutter ? 'g' : ''}`;
    return /*#__PURE__*/ _jsx("div", {
        id: id,
        className: `container-fluid ${containerMod} align--center ${className ? className : ''}`,
        ...extraProps,
        children: children
    });
};
export const Row = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "row",
        children: children
    });
};
export const Block = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: "page-block",
        children: children
    });
};
